import { Component } from "@angular/core";

@Component({
    selector: "about-component",
    template: require("./about.component.html")
})

export class AboutComponent {
    errorMessage: string;
    constructor() {
        this.errorMessage = "";
     }

    public ngOnInit() { }
}


// WEBPACK FOOTER //
// ./src/app/components/about/about.component.ts